export const removeDuplicatedObjectsFromArray = (array, propertyName) => {
  var uniqueValues = {};
  return array.filter((obj) => {
    var value = obj[propertyName];

    if (!Object.prototype.hasOwnProperty.call(uniqueValues, value)) {
      uniqueValues[value] = true;
      return true;
    }
    return false;
  });
};
